export default "__VITE_ASSET__DtAvNfFo__"